import axios from 'axios';
import { loginreq, req, getVerification } from './axiosFun';

// 登录接口
export const login = (params) => { return loginreq("post", "/api/common/login", params) };
// 验证码接口
export const verification = (params) => { return getVerification("get", "/api/common/verification", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => {
  return req("get", "/api/common/logout")
};
// 修改密码接口
export const updatePwd = (params) => { return req("post", "/api/auth/update/pwd", params) };
//获取用户sid
export const session = () => {
  return req("get", "/api/auth/subscribe/message/session")
};



// WEBPACK FOOTER //
// ./src/api/userMG.js